import { Component, NgModule, OnInit } from '@angular/core';
import { ContactUsData } from 'src/app/shared/models/registration';
import { RegistrationService } from 'src/app/shared/services/user/registration.service';

@Component({
  selector: 'app-outsourcing-pharmacy-info',
  templateUrl: './pharmacy-info.component.html',
  styleUrls: ['./pharmacy-info.component.scss'],
})
export class OutsourcingPharmacyInfoComponent implements OnInit {
  // contactData: ContactUsData = JSON.parse(JSON.stringify(pharmacyRegData));
  hasMessage = false;

  constructor(private registrationService: RegistrationService) {}

  ngOnInit() {}
}
